import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../buttons";
import Banner from "../banners";

export default function TopVideoSection() {
  const { t } = useTranslation();

  return (
    <section className="top-video-section">
      <h3 className="text-bold size-3 ls-0 text-center mb-3 natural-8">
        {t("get_your_personal_address")}
      </h3>
      <h6 className="size-8 natural-8 text-bold lh-24 text-center mb-32">
        {t("choose_products_online_store")}
      </h6>
      <Button className="m-auto natural-3" onClick={() => {}}>
        {t("learn_more_how_work")}
      </Button>
      <div className="video-banner text-center">
        <Banner src="/images/model.png" />
        <Button className="play-btn" onClick={() => {}}>
          <img src="/icons/play.svg" width={20} alt="play" />
        </Button>
      </div>
    </section>
  );
}
